export const labels = {
	select: {
		label: "Label.MobileCreator.PhotoSelection.Select",
		default: "Select",
	},
	remove: {
		label: "Label.MobileCreator.PhotoSelection.Remove",
		default: "Remove",
	},
	selectPhotos: {
		label: "Label.MobileCreator.PhotoSelection.SelectPhotos",
		default: "Select photos",
	},
	selectAll: {
		label: "Label.MobileCreator.PhotoSelection.SelectAll",
		default: "Select all",
	},
} as const;
